// En desarrollo el frontend corre en :3000 y Django en :9999.
// En producción Django sirve el build, así que la ruta relativa basta.
const API_BASE =
    process.env.NODE_ENV === "development" ? "http://127.0.0.1:9999" : "";

export const BLOG_API = `${API_BASE}/api/blog`;
